export default "__VITE_ASSET__Ct_sl1Y5__"